import React from 'react';
import { FaGithub } from 'react-icons/fa';
import { HiOutlineExternalLink } from 'react-icons/hi';
import movie from '../assets/movie.png';
// import tier from "../assets/3-tier.png";
// import ecommerece from "../assets/ecommerce.png";
// import portfolio from "../assets/portfolio.png";
import SectionHeading from './ui/SectionHeading';
import Reveal from './ui/Reveal';

const projects = [
    {
        id: 'movie-recommender',
        title: 'Movie Recommender System',
        description: 'Machine learning powered recommendation engine deployed on Streamlit.',
        image: movie,
        tags: ['Python', 'Machine Learning', 'Streamlit'],
        demoUrl: 'https://movie-recommender-system-sharvan.streamlit.app/',
        codeUrl: 'https://github.com/Sharvansamala/Movie-recommender-system',
    },
    // Hidden for now; uncomment (and the image imports above) to show again.
    // {
    //     id: 'ecommerce-backend',
    //     title: 'E-commerce Application',
    //     description: 'Scalable Spring Boot microservices backend with authentication and payment workflows.',
    //     image: ecommerece,
    //     tags: ['Java', 'Spring Boot', 'Microservices'],
    //     codeUrl: 'https://github.com/Sharvansamala/SpringBoot-Ecommerce',
    // },
    // {
    //     id: 'cloud-3tier',
    //     title: '3-Tier Cloud Architecture',
    //     description: 'High availability multi-tier web application deployed on AWS infrastructure.',
    //     image: tier,
    //     tags: ['AWS', 'High Availability', 'Cloud'],
    //     codeUrl: 'https://github.com/Sharvansamala',
    // },
    // {
    //     id: 'portfolio-site',
    //     title: 'Developer Portfolio',
    //     description: 'Interactive 3D portfolio built with React, Three.js and Tailwind CSS, tuned for performance.',
    //     image: portfolio,
    //     tags: ['React', 'Three.js', 'Tailwind CSS'],
    //     demoUrl: 'https://sharvansamala.com',
    //     codeUrl: 'https://github.com/Sharvansamala/portfolio',
    // },
];

const Work = () => {
    return (
        <section name="work" className='relative w-full py-24 sm:py-32 border-t border-slate-800/60'>
            <div className='max-w-[1160px] w-full mx-auto px-6 sm:px-8'>
                <SectionHeading eyebrow="Projects" title="Selected work" subtitle="Check out some of my recent work and open source projects" />

                <div className='flex flex-col gap-8'>
                    {projects.map((project) => (
                        <Reveal key={project.id}>
                            <article className='card group overflow-hidden grid md:grid-cols-[1.15fr_1fr] hover:border-slate-600 transition-colors'>
                                <div className='relative aspect-[16/10] md:aspect-auto md:min-h-[340px] overflow-hidden border-b md:border-b-0 md:border-r border-slate-800'>
                                    <img
                                        src={project.image}
                                        alt={`Preview of ${project.title}`}
                                        loading="lazy"
                                        className='absolute inset-0 w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500'
                                    />
                                </div>
                                <div className='p-6 sm:p-8 flex flex-col justify-center'>
                                    <p className='font-mono text-xs uppercase tracking-[0.2em] text-slate-500 mb-3'>Featured project</p>
                                    <h3 className='text-2xl font-bold text-slate-50 mb-3'>{project.title}</h3>
                                    <p className='text-slate-400 leading-relaxed mb-6'>{project.description}</p>
                                    <ul className='flex flex-wrap gap-x-4 gap-y-2 mb-8 font-mono text-xs text-slate-400'>
                                        {project.tags.map((tag) => (
                                            <li key={tag} className='px-0 cursor-default'>{tag}</li>
                                        ))}
                                    </ul>
                                    <div className='flex flex-wrap items-center gap-3'>
                                        {project.demoUrl && (
                                            <a href={project.demoUrl} target='_blank' rel="noreferrer noopener" className='btn-primary'>
                                                Live Demo <HiOutlineExternalLink />
                                            </a>
                                        )}
                                        {project.codeUrl && (
                                            <a href={project.codeUrl} target='_blank' rel="noreferrer noopener" className='btn-ghost'>
                                                <FaGithub /> Source Code
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Work;
